import React, { useState } from "react";
import classNames from "classnames";
// import CategoryItems from "../category-items/category-items";
// import Toggle from "./toggle-button/toggle";
import OverlayContainer from "../overlay-container/overlay-container";
import SearchResultsContainer from "./search-results-container/search-results.container";
import Select from "react-select";
import { shopify_sort_options, langOptions, suggestedOptions } from "../data/data";
import searchService from "../../services/searchService";
import Grid from "@mui/material/Grid";
import FiltersContainer from "./filters-container/filters-container";
import NoResults from "../no-results/no-results";
import debounce from "lodash/debounce";
import _, { uniqBy } from "lodash";
import styles from "./main.module.scss";
import * as Unicons from "@iconscout/react-unicons";
import { BottomSheet } from "react-spring-bottom-sheet";
import SuggestedQueries from "./suggested-queries/suggested-queries";
import "react-spring-bottom-sheet/dist/style.css";
import Typewriter from "typewriter-effect/dist/core";
import { GiConsoleController } from "react-icons/gi";

declare global {
  interface Window {
    isCustomStore: any;
  }
}

const store = process.env.REACT_APP_ECOMMERCE_STORE;
const languageToUse = process.env.REACT_APP_BUCKET_ZEVI_AI;
const type = process.env.REACT_APP_ECOMMERCE;

const options = shopify_sort_options;

enum SheetContent {
  Filters,
  Sort,
}

const Main: React.FC = () => {
  const [hasUserSearched, setHasUserSearched] = useState({ value: false, query: "" });
  const [based, setBased] = useState({ zevi: [], stringBased: [], filters: [] } as any);
  const [selectedSort, setSelectedSort] = useState(options[0]);
  const [localFilters, setLocalFilters] = useState({});
  const [filterKey, setFilterKey] = useState(0);
  const inputRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const [zeviSearchTotalCount, setZeviSearchTotalCount] = useState(0);
  const [simpleSearchTotalCount, setSimpleSearchTotalCount] = useState(0);
  const [zeviSearchPage, setZeviSearchPage] = useState(1);
  const [simpleSearchPage, setSimpleSearchPage] = useState(1);

  function resetPagination(count: number, searchCount: number) {
    setZeviSearchTotalCount(count);
    setSimpleSearchTotalCount(searchCount);
    setZeviSearchPage(1);
    setSimpleSearchPage(1);
  }

  function handleZeviSearchPageChage(page) {
    const inputElementValue = inputRef.current.value;

    searchService
      .searchZevi(store, inputElementValue, selectedSort, localFilters, page)
      .then((jsonResponses) => {
        const { ranked_list: zevi } = jsonResponses;
        setBased((prev) => ({
          ...prev,
          zevi: _.uniqBy([...based["zevi"], ...zevi], "id"),
        }));
        setZeviSearchPage(page);
      });
  }

  function handleSimpleSearchPageChange(page) {
    const inputElementValue = inputRef.current.value;
    searchService
      .searchElasticSearch(store, inputElementValue, selectedSort, localFilters, page)
      .then((jsonResponses) => {
        const { ranked_list: stringBased } = jsonResponses;

        setBased((prev) => ({
          ...prev,
          stringBased: _.uniqBy([...based["stringBased"], ...stringBased], "id"),
        }));
        setSimpleSearchPage(page);
      });
  }

  function search(query: string) {
    Promise.all([
      searchService.searchZevi(store, query, options[0]),
      searchService.searchElasticSearch(store, query, options[0]),
    ]).then((jsonResponses) => {
      const { ranked_list: zevi, filters, total_result_count: count } = jsonResponses[0];
      const { ranked_list: stringBased, total_result_count: countString } = jsonResponses[1];

      setHasUserSearched({
        value: true,
        query: query,
      });
      setBased({ zevi, stringBased, filters });
      resetPagination(count, countString);
      setFilterKey(filterKey + 1);
      setLocalFilters({});
      setSelectedSort(options[0]);
    });
  }

  function handleKeyPress(e: any) {
    if (!(e.key === "Enter")) {
      return;
    }

    if (!e.target.value) {
      return;
    }

    search(e.target.value);
  }

  return (
    <main className={styles.main}>
      <h1>{type === "oziva" ? "Wellness products" : "Fashion products"}</h1>
      <div className={styles.inputContainer}>
        <input
          type="text"
          ref={inputRef}
          required
          onKeyPress={handleKeyPress}
          className={styles.input}
          placeholder={
            type === "oziva"
              ? "Search for Products, Symptoms etc..."
              : "Search for Products, Occasion etc..."
          }
        />
        <div className={styles.language}>{languageToUse ? "Hindi + English" : "English"}</div>
      </div>
      {hasUserSearched.value && (
        <div className={styles.container}>
          <div className={styles.desktop}>
            <SearchResultsContainer
              zeviProducts={based["zevi"]}
              stringBasedProducts={based["stringBased"]}
              zeviSearchTotalCount={zeviSearchTotalCount}
              simpleSearchTotalCount={simpleSearchTotalCount}
              handleSimpleSearchPageChange={handleSimpleSearchPageChange}
              zeviSearchPage={zeviSearchPage}
              handleZeviSearchPageChage={handleZeviSearchPageChage}
              simpleSearchPage={simpleSearchPage}
            />
          </div>
          <div className={styles.mobile}>
            <SearchResultsContainer
              zeviProducts={based["zevi"]}
              stringBasedProducts={based["stringBased"]}
              zeviSearchTotalCount={zeviSearchTotalCount}
              simpleSearchTotalCount={simpleSearchTotalCount}
              handleSimpleSearchPageChange={handleSimpleSearchPageChange}
              zeviSearchPage={zeviSearchPage}
              handleZeviSearchPageChage={handleZeviSearchPageChage}
              simpleSearchPage={simpleSearchPage}
            />
          </div>
        </div>
      )}
    </main>
  );
};

export default Main;
